const accountsWithKBA = [
	'RightSignature Enterprise SO PHI',
	'RightSignature Enterprise SFPremium WSA',
	'RightSignature KBA 20+',
	'RightSignature KBA 3',
	'RightSignature Advanced KBA',
	'RightSignature Enterprise VDR',
	'RightSignature for SFPrm - SBM',
	'RightSignature Advanced KBA Hybris',
	'RightSignature KBA 5',
	'RightSignature KBA 10',
	'RightSignature KBA 15',
	'RightSignature for SFPrm - SB1',
	'RightSignature for SFPrm - SB2',
	'RightSignature for SFPrm - SB3',
	'RightSignature for SFPrm - SB4',
	'RightSignature for SFPrm - SB5',
	'RightSignature Enterprise SFPremium',
	'RightSignature KBA',
	'RightSignature for SFPrm',
	'RightSignature for SFPrm Hybris',
	'RightSignature KBA Hybris',
	'RightSignature for SFIA',
];

export default accountsWithKBA;
